<template>
    <el-row class="padding-bottom-row">
      <el-col :span="2">
        <div class="content-label">退款asin列表</div>
        </el-col>
      <el-col :span="22">
        <el-table :data="tableData" border show-summary :summary-method="tableSummaryMethod">
          <el-table-column type="expand" label="操作">
            <template v-slot="scope">
              <el-table :data="scope.row.amazonInboundRecordDtoList" border  style="margin-left: 47px;padding-right:47px;">
                <el-table-column prop="id" label="采购编号"> </el-table-column>
                <el-table-column prop="" label="创建时间" width="100">
                  <template v-slot="scope">
                    {{scope.row.createTime.split(" ")[0]}}
                    <br>
                    {{scope.row.createTime.split(" ")[1]}}
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量"> </el-table-column>
                <el-table-column prop="unitPrice" label="单价"> </el-table-column>
                <el-table-column prop="totalCost" label="总费用"> </el-table-column>
                <el-table-column prop="purchaseUserName" label="操作人"> </el-table-column>
                <el-table-column prop="purchaseAccount" label="采购账户"> </el-table-column>
                <el-table-column prop="supplierName" label="供应商"> </el-table-column>
                <el-table-column prop="commoditySourceOrderNo" label="供应商订单号">
                </el-table-column>
                <el-table-column prop="logisticsOrgTypeLabel" label="卖家告知采购物流公司">
                </el-table-column>
                <el-table-column prop="logisticsOrderNo" label="卖家告知采购物流单号">
                </el-table-column>
                <el-table-column prop="purchaseOrderLogisticsOrderNo" label="1688物流单号">
                </el-table-column>
                <el-table-column label="采购状态/1688订单状态">
                  <template v-slot="scope">
                    {{scope.row.purchaseStatusLabel}}
                    <br>
                    {{scope.row.purchaseOrderStatus}}
                  </template>
                </el-table-column>
                <el-table-column prop="inboundQuantity" label="质检入库"> </el-table-column>
                <el-table-column prop="damageQuantity" label="损毁"> </el-table-column>
                <el-table-column label="退货数量/1688退货金额">
                  <template v-slot="scope">
                    {{scope.row.returnQuantity}}
                    <br>
                    {{scope.row.refund}}
                  </template>
                </el-table-column>
                <el-table-column label="退货状态/1688退货状态">
                  <template v-slot="scope">
                    {{scope.row.returnPurchaseStatusLabel}}
                    <br>
                    {{scope.row.refundStatus}}
                  </template>
                </el-table-column>
                <el-table-column prop="offsetQuantity" label="长短货"> </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="rawMaterialId" type="index" label="材料Id">
          </el-table-column>
          <el-table-column label="商品图标">
            <template v-slot="scope">
              <el-image
                style="height: 40px; width: 40px"
                :src="scope.row.smallImageURL"
                fit="fill"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="innerName" label="中文简称"> </el-table-column>
          <el-table-column prop="unitPrice" label="加权平均单价"> </el-table-column>
          <el-table-column prop="totalReturnQuantity" label="退货数量"> </el-table-column>
          <el-table-column prop="totalReturnAmount" label="退货金额"> </el-table-column>
          <el-table-column prop="totalExchangeQuantity" label="换货数量"> </el-table-column>
          <el-table-column prop="totalExchangeAmount" label="换货金额"> </el-table-column>
          <el-table-column prop="totalRefundQuantity" label="退款数量"> </el-table-column>
          <el-table-column prop="totalRefundAmount" label="退款金额"> </el-table-column>
          <el-table-column label="实际退款金额"> </el-table-column>
          <el-table-column label="坏账金额"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            default () {
                return []
            }
        },
        refundTableData: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {

        }
    },
    methods: {
        tableSummaryMethod (param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if([1,2,3,4].includes(index)){
                    sums[index] = '';
                    return;
                }
                if(index === 11){
                   sums[11] = 0;
                    if(this.refundTableData.length <= 0){
                      return;
                    }
                    this.refundTableData.forEach((item) => {
                      sums[index] += parseFloat(item.amount ? item.amount : 0) * (item.direction ? item.direction : 0);
                    });
                    return;
                }
                if(index == 12){
                    sums[12] = sums[10] - sums[11];
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return (prev * 10000 + curr * 10000) / 10000;
                    } else {
                        return prev * 10000 / 10000;
                    }
                    }, 0);
                } else {
                    sums[index] = '';
                }
                });
            return sums;
        }
    }
}
</script>

<style>

</style>